import styled from 'styled-components';

export const StyledHeader = styled.header`
  position: sticky;
  height: 6vh;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  padding: 0 var(--space-4);
  background-color: rgba(10, 10, 12, 0.8);
  backdrop-filter: blur(12px);
  border-bottom: var(--border);

  .logo {
    display: flex;
    align-items: center;
  }

  .logo__svg {
    width: 32px;
    height: 32px;
  }

  .logo__svg path {
    fill: var(--c-text);
    transition: fill 0.2s ease;
  }

  .logo:hover .logo__svg path {
    fill: var(--c-accent);
  }

  .navbar {
    display: flex;
    align-items: center;
    gap: var(--space-2);
  }

  @media (min-width: 786px) {
    padding: 0 var(--space-6);

    .logo__svg {
      width: 38px;
      height: 38px;
    }

    .navbar {
      gap: var(--space-4);
    }
  }

  @media (min-width: 1200px) {
    padding: 0 var(--space-8);
  }
`;
